import { render, staticRenderFns } from "./StandardReportConfig.vue?vue&type=template&id=3a450bea&scoped=true"
import script from "./StandardReportConfig.vue?vue&type=script&lang=js"
export * from "./StandardReportConfig.vue?vue&type=script&lang=js"
import style0 from "./StandardReportConfig.vue?vue&type=style&index=0&id=3a450bea&prod&lang=scss"
import style1 from "./StandardReportConfig.vue?vue&type=style&index=1&id=3a450bea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a450bea",
  null
  
)

export default component.exports